import React, { useState, useMemo } from 'react';
import Modal from 'react-modal';
import { Link as Anchor } from 'react-router-dom';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile'
import './Navbar.css'

import Favoritos from '../Favoritos/Favoritos'
import InputSerach from '../InputSerach/InputSearchs'
import EstadoAbierto from '../EstadoAbierto/EstadoAbierto'
import { useData } from '../DataContext';
import { useLogo } from '../LogoContext';
import { ruta } from '../paths';
export default function Navbar() {
    const { banners, loading } = useData();
    const { logo } = useLogo();
    const [isOpen, setIsOpen] = useState(false);

    const images = useMemo(() => (banners || []).map(banner => banner.imagen), [banners]);

    return (
        <header>
            <nav>
                <Anchor to={ruta('/')} className='logo'>
                    <img src={logo} alt="logo" />
                </Anchor>

                <EstadoAbierto />

                <div className='deFLexNavs'>

                    <Favoritos />

                    <InputSerach />
                    <div className={`nav_toggle  ${isOpen && "open"}`} onClick={() => setIsOpen(!isOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>


                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay"
                >
                    <div className="modalNav-content">
                        {loading ? (
                            <div className='loadingBannerFondo'>

                            </div>

                        ) : (

                            <>
                                <div className='fondo'>
                                    <img src={images[0]} alt={`imagen`} />

                                </div>
                                <Profile />

                            </>
                        )}

                    </div>
                </Modal>

            </nav>
        </header>
    );
}
